


















































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { initOrderDetail } from '@/web-task/utils/order'
import tabs from '../AiiTasks/Tabs.vue'

@Component({
	name: 'HelpCenter',
	components: {
		tabs,
	},
})
export default class QueryList extends Vue {
	private title: any = ''
	private injured: any = ''
	private order: any = ''
	private show: any = ''
	private tabs: any = {
		index: '1',
		items: [
			{
				key: '1',
				title: '基本信息',
			},
			{
				key: '2',
				title: '影像信息',
			},
		],
		active: () => {
			return this.tabs.index
		},
		callback: (key: any) => {
			this.tabs.index = key
		},
	}

	private get isLivingInvestigate() {
		return this.$route.query.taskType === '4'
	}

	private get isWorkInvestigate() {
		return this.$route.query.taskType === '5'
	}

	private get isPureMediate() {
		return this.$route.query.taskType === '9'
	}

	private get isOtherMediate() {
		return this.$route.query.taskType === '8'
	}

	private get isOtherInvestigate() {
		return this.$route.query.taskType === '15'
	}

	private get isHomeInvestigate() {
		// 是伤者家中调查
		return this.$route.query.taskType === '16'
	}

	private created() {
		// 调解tabs调整
		if (this.isOtherMediate || this.isPureMediate) {
			this.tabs.items.unshift({
				key: '0',
				title: '调解信息',
			})
			if (this.isOtherMediate) {
				this.tabs.items.splice(1, 1)
			}
			this.tabs.index = '0'
		}
		const type: any = {
			1: '初次探视获取信息',
			2: '住院复勘获取信息',
			3: '活动度复勘获取信息',
			4: '居住地真实性调查获取信息',
			5: '工作真实性调查获取信息',
			8: '住院案件调解获取信息',
			9: '门诊案件调解获取信息',
			15: '其他调查',
		}
		this.title = type[this.$route.query.taskType as any]

		let injured: any = {
			age: 28,
			agent: {
				agentPhone: '13666666666',
				agentor: '职业代理人',
				hasAgent: '1',
				remark: '',
			},
			accidentInfo: {
				accDesc: '老张开车去东北，撞了',
				accTime: '2019-08-22T16:00:00.000Z',
				address: '长江大桥',
				injuryType: '01',
				isIllegal: '05',
				otherIllegal: '05',
				position: '01',
				travelModel: '01',
			},
			birthday: 688665600000,
			caregiversDto: {
				hasCaregivers: '1',
				caregiversInfoList: [
					{
						caregiversIdentity: '01',
						caregiversName: '李某',
						jobName: '护工',
						nursingCost: '666',
						orderNum: 1,
						workingPlace: '才华有限公司',
					},
				],
			},
			censusRegisterAddress: '铁岭莲花乡',
			censusRegisterType: '01',
			familyDto: {
				familyInfoList: [
					{
						age: '61',
						areaCode: '440305',
						censusRegisterType: '01',
						cityCode: '440300',
						dependCount: '1',
						dependType: '02',
						detailAddress: '天桥下',
						formatAddress: '广东省深圳市南山区',
						fosterRelation: '嗲嗲',
						income: '8888',
						incomePredictType: '01',
						name: '嗲嗲',
						orderNum: '1',
						provinceCode: '440000',
						remark: '',
						typeDesc: '60岁以上父母',
						workStatus: '0',
					},
				],
				hasFamily: 1,
			},
			idNo: '533001197110292222',
			idType: '01',
			inHospital: '1',
			injuredInfo: {
				alreadySpent: 12.0,
				awayInHospital: '1',
				bedNo: 'A5',
				diagnoseName: '啊啊',
				factVisitingDepartment: '骨科',
				factVisitingHospital: '市二医院',
				hospitalizedDate: 1566403200000,
				inHospitalHours: 12.0,
				latitude: '',
				longitude: '',
				mentalStatus: '01',
				operationName: '啊啊',
				remainSpent: 12.0,
				selfDressing: '1',
				selfFeeding: '1',
				selfTurning: '1',
				selfUrinating: '1',
				selfWashing: '1',
				spentPredictType: '01',
				referralWays: '01',
				treatWays: '01',
				treatment: '01',
				surgeries: [
					{
						surgery: '开颅手术',
						surgeryTime: 1566403200000,
					},
				],
			},
			injuredSignature: '王某',
			injuredRelation: '大舅子',
			mediaInfoList: [
				{
					orderNum: 1,
					picId: 'a201908231',
					picName: '伤者身份证正面',
					picUrl: '/demo/身份证正面.png',
					type: '0003',
				},
				{
					orderNum: 1,
					picId: 'a201908232',
					picName: '伤者身份证反面',
					picUrl: '/demo/身份证反面.png',
					type: '0004',
				},
				{
					orderNum: 1,
					picId: 'a201908233',
					picName: '对比照',
					picUrl: '/demo/身份证对比照.png',
					type: '0002',
				},
				{
					orderNum: 1,
					picId: 'a201908234',
					picName: '护理人照片',
					picUrl: '/demo/护理人照片.png',
					type: '0801',
				},
				{
					orderNum: 1,
					picId: 'a201908235',
					picName: '护理人资料',
					picUrl: '/demo/护理人资料.png',
					type: '0802',
				},
				{
					orderNum: 1,
					picId: 'a201908236',
					picName: '医院门牌照',
					picUrl: '/demo/医院门牌照.png',
					type: '0106',
				},
				{
					orderNum: 1,
					picId: 'a201908237',
					picName: '科室门牌照',
					picUrl: '/demo/科室门牌.png',
					type: '0101',
				},
				{
					orderNum: 1,
					picId: 'a201908238',
					picName: '病房门牌照',
					picUrl: '/demo/病房牌照.png',
					type: '0102',
				},
				{
					orderNum: 1,
					picId: 'a201908239',
					picName: '床头卡',
					picUrl: '/demo/床头卡.png',
					type: '0103',
				},
				{
					orderNum: 1,
					picId: 'a201908240',
					picName: '伤者全身照',
					picUrl: '/demo/伤者全身照.png',
					type: '0104',
				},
				{
					orderNum: 1,
					picId: 'a201908241',
					picName: '受伤局部照',
					picUrl: '/demo/受伤局部照.png',
					type: '0105',
				},
				{
					orderNum: 1,
					picId: 'a201908242',
					picName: '诊断证明',
					picUrl: '/demo/诊断证明.png',
					type: '0201',
				},
				{
					orderNum: 1,
					picId: 'a201908243',
					picName: '门诊病历本',
					picUrl: '/demo/病历本.png',
					type: '0202',
				},
				{
					orderNum: 1,
					picId: 'a201908244',
					picName: '检查报告',
					picUrl: '/demo/检查报告.png',
					type: '0203',
				},
				{
					orderNum: 1,
					picId: 'a201908245',
					picName: '影像片-片子全貌',
					picUrl: '/demo/影像全貌.png',
					type: '0501',
				},
				{
					orderNum: 1,
					picId: 'a201908245',
					picName: '影像片-片头',
					picUrl: '/demo/影像片头.png',
					type: '050101',
				},
				{
					orderNum: 1,
					picId: 'a201908245',
					picName: '影像片-受伤细节',
					picUrl: '/demo/影像受伤细节.png',
					type: '050102',
				},
				{
					orderNum: 1,
					picId: 'a201908246',
					picName: '伤者(家属)签名',
					picUrl: '/demo/伤者签名.png',
					type: '0301',
				},
				{
					orderNum: 1,
					picId: 'a201908247',
					picName: '作业人员签名',
					picUrl: '/demo/探视员签名.png',
					type: '0302',
				},
				{
					orderNum: 1,
					picId: 'a201908249',
					picName: '银行卡正面',
					picUrl: '/demo/银行卡.png',
					type: '0601',
				},
				{
					orderNum: 1,
					picId: 'a201908249',
					picName: '其他',
					picUrl: '/demo/其他.png',
					type: '0900',
				},
				{
					orderNum: 1,
					picId: 'a201908250',
					picName: '病床照',
					picUrl: '/demo/病床照.png',
					type: '0107',
				},
				{
					orderNum: 1,
					picId: 'a201908251',
					picName: '床头卡病床合影',
					picUrl: '/demo/床头卡病床合影.png',
					type: '0108',
				},
				{
					orderNum: 1,
					picId: 'a201908252',
					picName: '医嘱',
					picUrl: '/demo/医嘱.png',
					type: '0502',
				},
				{
					orderNum: 1,
					picId: 'a201908253',
					picName: '每日费用清单',
					picUrl: '/demo/费用清单.png',
					type: '0503',
				},
			],
			name: '李某',
			phone: '13666666666',
			referralWays: '01',
			sex: '1',
			treatWays: '01',
			treatment: '01',
			visitorInfo: {
				visitorCardNo: 'CIAS0000003',
				visitorPhone: '13666666666',
				visitorSignature: '李某',
			},
			livingInfoList: [
				{
					areaCode: '440305',
					beginDate: '2019-08-22T16:00:00.000Z',
					cityCode: '440300',
					detailAddress: '天桥下',
					endDate: '2019-08-22T16:00:00.000Z',
					homeAddress: '广东省深圳市南山区',
					orderNum: '0',
					provinceCode: '440000',
				},
			],
			work: {
				hasWork: '1',
				workInfoList: [
					{
						areaCode: '440305',
						beginDate: '2019-08-22T16:00:00.000Z',
						cityCode: '440300',
						companyName: '才华有限公司',
						endDate: '2019-08-22T16:00:00.000Z',
						jobName: '包工头',
						orderNum: 1,
						provinceCode: '440000',
						wage: '6666',
						wageType: '02',
						workAddress: '广东省深圳市南山区',
						workPlace: '天桥下',
					},
				],
			},
		}

		let order = {
			applyCancels: [],
			auditLogs: [],
			auditorName: '李某',
			auditorPhone: '13666666666',
			auditTime: 1566469791000,
			cancelReason: '',
			carNo: '无牌',
			caseNo: 'a123456',
			clinicArea: '广东省深圳市南山区',
			company: '才华有限公司',
			contact: '李某',
			contactPhone: '13666666666',
			createTime: 1566469731000,
			creator: 53,
			creatorName: '李某',
			creatorPhone: '13666666666',
			department: '骨科',
			endTime: 1566649800000,
			hospital: '市二医院',
			injuredName: '李某',
			injuredPhone: '13666666666',
			operationId: 1031,
			operationStatus: '03',
			orderNo: '200153000019082200000000',
			orderStatus: '04',
			ownerName: '啊啊',
			ownerPhone: '13666666666',
			phone: '',
			returnFlag: '0',
			serverTime: 1566524007831,
			serviceCompanyName: '中保车服科技服务股份有限公司',
			taskType: this.$route.query.taskType,
			visitRequest: '',
			visitTime: 1566469749000,
			insuranceType: '01',
			locationType: '1',
			injuryPositions: '1101,1102',
		}

		injured = initOrderDetail({
			injured,
			order,
		})
		this.order = order
		this.injured = injured
	}

	private get supplyInfo() {
		return ''
	}
}
